import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box, useTheme, useMediaQuery } from '@material-ui/core';
import { registerClientReset } from 'app/store/client-onboarding';
import { registerHeroReset } from 'app/store/hero-onboarding';
import ChooseRoleTable from './choose-role/ChooseRoleTable';
import ChooseRoleList from './choose-role/ChooseRoleList';
import { trackGTMEvent } from 'app/helpers/trackGTMEvent';

export interface ChooseRoleProps {
  clientRegisterLink: string;
  heroRegisterLink: string;
  headingSectionOverTitle: string;
  showAlreadyHaveAccount: boolean;
}

export default function ChooseRole(props: ChooseRoleProps) {
  const { showAlreadyHaveAccount } = props;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const dispatch = useDispatch();

  useEffect(() => {
    const props = {
      'pageRef': 'Choose Role',
      'pageUrl': window.location.href,
      'pagePath': window.location.pathname,
    };
    trackGTMEvent('customPageView', props);
  }, []);

  // reset registration stores
  dispatch(registerClientReset());
  dispatch(registerHeroReset());

  return (
    <>
      {matches ? <ChooseRoleTable {...props} /> : <ChooseRoleList {...props} />}
      {showAlreadyHaveAccount && (
        <Box display="flex" justifyContent="center" fontSize="1.6rem" mt={-6}>
          <p>
            Already have an account? <Link to="/auth/login">Log in</Link>
          </p>
        </Box>
      )}

      <Box fontSize="1.6rem" textAlign="center" px={2}>
        <p>
          Talk to a real person?{matches ? '' : <br />} Call{' '}
          <a href="tel:2345678911">+1 (234) 567-8911</a>
        </p>
      </Box>
    </>
  );
}
